<template>
  <div class="ask-export">
    <!-- 专家详情 -->
    <div class="export-info">
      <!-- 专家图片 -->
      <div class="export-info-img">
        <img
          :src="exportInfo.userAvatarUrl || BASE_URL + 'img/zwt.png'"
          width="162px"
          height="162px"
          :alt="exportInfo.name"
        />
      </div>
      <!-- 专家信息 -->
      <div class="export-info-detail">
        <h4>{{ exportInfo.name }}</h4>
        <!-- 专家标签 -->
        <div
          class="export-info-detail-category overell"
          v-if="
            exportInfo &&
            exportInfo.fileVideoTypeAttributeEntityList &&
            exportInfo.fileVideoTypeAttributeEntityList.length
          "
        >
          <span
            style="color: #999"
            v-for="item in exportInfo.fileVideoTypeAttributeEntityList"
            :key="item.id"
            >{{ item.typeAttributeValue }}</span
          >
        </div>
        <div class="export-info-detail-introduction">
          <p
            style="
              width: inherit;
              height: 49px;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            "
          >
              <!-- overflow: hidden; -->
            {{ exportInfo.expertIntroduction }}
          </p>
        </div>
        <div class="export-info-opt">
          <router-link
            style="
              height: 42px;
              border: 1px solid #1d65a8;
              color: #1d65a8;
              line-height: 42px;
              text-align: center;
              user-select: none;
              cursor: pointer;
            "
            to="/chooseExpert"
            tag="div"
          >
            <div class="replaceExpert">更换专家</div>
          </router-link>
          <div class="export-info-opt-label">
            <div class="export-about-info" @click="routerHandleExportDetail">
              <div class="info-count">{{ exportInfo.questionCount || 0 }}</div>
              <div>提问数</div>
            </div>
            <div class="export-about-info" @click="routerHandleExportDetail">
              <div class="info-count">{{ exportInfo.replyCount || 0 }}</div>
              <div>回答数</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ask-content">
      <el-input
        type="text"
        maxlength="100"
        v-model="posts.title"
        placeholder="请输入标题（最多100字）"
        class="ask-content-title"
      ></el-input>
      <el-input
        type="textarea"
        v-model="posts.content"
        :autosize="{ minRows: 10 }"
        maxlength="2000"
        placeholder="请提出你的问题"
      ></el-input>
      <div class="ts" style="text-align: right">
        您还可以输入{{ 2000 - posts.content.length }}字
      </div>
      <!-- 增加图片,限制5张 -->
      <!-- =================================================================================== -->
      <!-- <el-upload
        :action="action"
        :on-success="successFile"
        list-type="picture-card"
        :auto-upload="true"
        :before-upload="beforeUpload"
        :limit="5"
        :on-exceed="exceedLimitHandle"
        ref='upload'
      >
        <div
          slot="tip"
          class="el-upload__tip"
          v-show="LimitTheLength"
          style="color: red"
        >
          您可至多上传五张图片！
        </div>
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{ file }">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleDownload(file)"
            >
              <i class="el-icon-download"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </el-upload> -->
      <el-upload
        :action="action"
        :on-success="successFile"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove"
        :before-upload="beforeUpload"
        :data="{
          fileSuffixType: 'picture2'
        }"
        :limit="5"
        :on-exceed="exceedLimitHandle">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
      <!-- =================================================================================== -->
      <div style="text-align: right">
        <div
          @click="cancle()"
          :class="'hotComment-content-button-but hotComment-content-button-cancle'"
        >
          取消
        </div>
        <div @click="submitHandle()" :class="'hotComment-content-button-but '">
          提交问题
        </div>
      </div>
      <!-- <div class="ask-content-button">
            <el-button @click="cancle()" :loading="butLoading">取消</el-button>
            <el-button @click="submitHandle()" :loading="butLoading">提交问题</el-button>
        </div> -->
    </div>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import { expertDetail } from '@/utils/eventTracking'
export default {
  data () {
    return {
      LimitTheLength: false,
      fileList: [],
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/v2/upload',
      BASE_URL: process.env.BASE_URL,
      exportInfo: {},
      posts: {
        title: '',
        content: ''
        // picInfo: [],
      },
      butLoading: false,
      // pic
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false
    }
  },
  computed: {
    exportId () {
      return this.$route.query.id
    },
    jisuan () {
      return 'aaa'
    }
  },
  mounted () {
    if (this.exportId) {
      this.getExportInfo()
    }
  },
  methods: {
    // 跳转专家详情
    routerHandleExportDetail () {
      expertDetail(this.exportInfo.name)
      this.$router.push({
        name: 'exportDetail',
        query: {
          id: this.exportInfo.id,
          uId: this.exportInfo.userId
        }
      })
    },
    // 获取专家信息
    getExportInfo () {
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldrepliy/info/${this.exportId}`
        )
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.exportInfo = data.data
          } else {
            this.exportInfo = {}
          }
        })
    },
    submitHandle () {
      if (!this.posts.title) {
        this.$message.error('帖子标题不能为空')
        return
      }
      if (!this.posts.content) {
        this.$message.error('帖子内容不能为空')
        return
      }
      this.butLoading = true
      this.$http
        .post(
          `${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/save`,
          {
            articleTitle: this.posts.title,
            expertId: this.exportId,
            articleContent: this.posts.content,
            // 增加图片字段
            fileList: this.fileList
          }
        )
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('提问成功')
            this.$router.go(-1)
          } else {
            this.$message.error(data.msg || '提问失败')
          }
          this.butLoading = false
        })
        .catch(() => {
          this.butLoading = false
        })
    },
    cancle () {
      this.$router.go(-1)
    },
    // pic
    handleRemove (file, fileList) {
      console.log(file)
      let index = this.fileList.findIndex(item => {
        return item === file.response.data.aliOssId
      })
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
      // this.file.splice(0,1)

      // for (var i in this.fileList.files) {
      //   for (var k in this.fileList.files[i]) {
      //     if (this.fileList.files[i][k] == file.uid) {
      //       delete this.fileList.files[i];
      //       break;
      //     }
      //   }
      // }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleDownload (file) {
      console.log(file)
    },
    changeGetFile (file, fileList) {
      this.picInfo = [...fileList]
      // console.log(this.picInfo);
      console.log(this.fileList)

      // this.fileList = fileList.slice(-3);

      // 图片接口 get ossid
      // this.$http.post(`/front/fileupload/alioss/upload`).then(({ data:res })=>{
      //   if(res && res.code === 0) {
      //     console.log(res);
      //   };
      // })
    },
    exceedLimitHandle () {
      this.$message.warning(`当前限制选择 5 张图片`)
    },
    beforeUpload (file) {
      let type = file.name.substring(file.name.lastIndexOf('.'))
      const isLt2M = file.size / 1024 / 1024 < 8
      var reg = /\.(jpg|bmp|gif|jpeg|png)$/
      const isJPG = reg.test(type)
      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg|bmp|gif|jpeg|png 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 8MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
      return isJPG && isLt2M
    },
    // 上传图片
    successFile (resolveponse, file) {
      // 允许上传图片
      if (resolveponse.code === 0) {
        console.log('上传')
        this.fileList.push(resolveponse.data.aliOssId)
      } else {
        this.$message.error(resolveponse.message)
        console.log('上传失败')
      }
    }
  },
  watch: {
    exportId (newVal) {
      if (newVal) {
        this.getExportInfo()
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!getAccessToken()) {
      next({ name: 'login' })
    } else {
      next()
    }
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
  }
}
</script>
<style scoped>
.ask-export {
  background-color: #fff;
  padding: 30px 30px;
  word-wrap: break-word;
  word-break: break-all;
}
.export-info {
  margin: 0;
  width: 860px;
  /* height: 300px; */
  /* border: 1px solid #0c0c0c; */
  display: flex;
  box-shadow: none;
}
.export-info-img {
  width: 200px;
  /* display: inline-block; */
}
.export-info-img img {
  width: 160px;
  height: 162px;
  display: inline-block;
}
.export-info-detail {
  display: inline-block;
  position: relative;
  top: 0;
  left: 0;
  width: 70%;
}
.export-info-detail-category {
  width: 100%;
  margin-top: 6px;
  margin-bottom: 8px;
  text-align: left;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #262626;
  overflow: hidden;
}
.export-info-detail-category span {
  margin-right: 10px;
}
.export-info-detail-introduction {
  width: 100%;
  text-align: left;
  line-height: 22px;
  height: 60px;
  overflow-y: auto;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.4px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  /* -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; */
}
.export-info-opt {
  /* margin-bottom: 10px; */
  margin-top: 10px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
}
.export-info-opt-label {
  text-align: right;
  width: 100%;
  display: inline-block;
  margin-right: 0;
  color: #999;
}
.export-about-info {
  margin-right: 10px;
  display: inline-block;
  align-items: center;
  width: 50px;
  cursor: pointer;
  /* width: 100px; */
}
.export-about-info:hover {
  color: #1d65a8;
}
.info-count {
  text-align: center;
  color: #1d65a8;
}
.ask-content {
  margin: 20px 0;
}
.ts {
  text-align: right;
  line-height: 30px;
  font-size: 14px;
  color: #acacac;
  height: 30px;
}
.ask-content-button {
  width: 100%;
  margin: 10px auto;
  padding-right: 0px;
  margin-right: 0px;
}
.ask-content-button button {
  float: right;
  margin-right: 10px;
}
.ask-content-title {
  height: 20px;
  line-height: 20px;
  margin-bottom: 30px;
}
.replaceExpert {
  width: 98px;
  height: 42px;
  padding: 0;
  margin: 0;
  display: inline-block;
}
.replaceExpert:hover {
  background: #1d65a8;
  color: white;
}
.hotComment-content-button-but {
  vertical-align: top;
  display: inline-block;
  background: #1d65a8;
  text-align: center;
  width: 150px;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  color: #fff;
  cursor: pointer;
}
.hotComment-content-button-cancle {
  border: 1px solid #1d65a8;
  color: #1d65a8;
  background: #fff;
}
.hotComment-content-button-cancle:hover {
  background: #1d65a8;
  color: white;
}
h4 {
  margin: 0;
}
p {
  margin: 0;
}
</style>
